import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91752240"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-row gap-2 col-12",
  style: {"align-items":"center !important"}
}
const _hoisted_2 = {
  key: 0,
  class: "bg-success",
  style: {"min-width":"10px","height":"10px","border-radius":"50%"}
}
const _hoisted_3 = {
  key: 1,
  class: "bg-warning",
  style: {"min-width":"10px","height":"10px","border-radius":"50%"}
}
const _hoisted_4 = {
  key: 2,
  class: "bg-secondary",
  style: {"min-width":"10px","height":"10px","border-radius":"50%"}
}
const _hoisted_5 = {
  key: 3,
  width: "30",
  height: "30",
  viewBox: "0 0 51 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M48.3945 35.3671V40.9921C48.3945 41.1728 48.3737 41.3529 48.3323 41.5289L46.4573 49.4977C46.2082 50.5563 45.2634 51.3046 44.1758 51.3046H31.9883C31.6186 51.3046 31.2542 51.2171 30.9247 51.0494C30.5953 50.8816 30.3102 50.6383 30.0928 50.3394L22.593 40.0269C21.8316 38.98 22.0631 37.5142 23.1099 36.7529C24.1568 35.9915 25.6226 36.223 26.3839 37.2698L28.2383 39.8197V23.6483C28.2383 22.3539 29.2876 21.3046 30.582 21.3046C31.8765 21.3046 32.9258 22.3539 32.9258 23.6483V35.3671H33.3945V33.0233C33.3945 31.7289 34.4438 30.6796 35.7383 30.6796C37.0327 30.6796 38.082 31.7289 38.082 33.0233V35.3671H38.5508V33.9608C38.5508 32.6664 39.6001 31.6171 40.8945 31.6171C42.189 31.6171 43.2383 32.6664 43.2383 33.9608V35.3671H43.707C43.707 34.0727 44.7563 33.0233 46.0508 33.0233C47.3452 33.0233 48.3945 34.0727 48.3945 35.3671Z",
  fill: "#203972"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { opacity: "0.3" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.50016 3.73846H46.1668C48.4672 3.73846 50.3335 5.60478 50.3335 7.90513V31.0319C49.2329 29.9446 47.7203 29.2733 46.0509 29.2733C45.662 29.2733 45.2815 29.3097 44.9128 29.3794C44.8684 29.3404 44.8235 29.3021 44.7779 29.2644V9.29402H5.88905V34.294H20.2243C18.7262 35.7575 18.1153 37.8654 18.5129 39.8496H4.50016C2.19982 39.8496 0.333496 37.9833 0.333496 35.6829V7.90513C0.333496 5.60478 2.19982 3.73846 4.50016 3.73846Z",
    fill: "#203972"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.1173 42.9983L19.7779 44.0162H13.5279C12.3734 44.0162 11.4446 44.9451 11.4446 46.0996C11.4446 47.2541 12.3734 48.1829 13.5279 48.1829H23.8878L20.1173 42.9983Z",
    fill: "#203972"
  })
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 4,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M15.0005 21H6.00053V13.5H3.00053V25.5C3.00053 26.3297 3.67084 27 4.50053 27H16.5005C17.3302 27 18.0005 26.3297 18.0005 25.5V13.5H15.0005V21ZM29.7474 9.66562L25.749 3.66562C25.4677 3.24844 24.999 3 24.4974 3H5.50365C5.00209 3 4.53334 3.24844 4.25678 3.66562L0.258343 9.66562C-0.407282 10.6641 0.305217 12 1.50522 12H28.5005C29.6958 12 30.4083 10.6641 29.7474 9.66562ZM24.0005 26.25C24.0005 26.6625 24.338 27 24.7505 27H26.2505C26.663 27 27.0005 26.6625 27.0005 26.25V13.5H24.0005V26.25Z",
  fill: "#203972"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M29.7464 9.66562L25.748 3.66562C25.4667 3.24844 24.998 3 24.4964 3H5.50268C5.00112 3 4.53237 3.24844 4.2558 3.66562L0.257366 9.66562C-0.408259 10.6641 0.304241 12 1.50424 12H28.4996C29.6949 12 30.4074 10.6641 29.7464 9.66562Z",
  fill: "#203972"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 5,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M28.125 4.28572V6.96428C28.125 9.32479 22.2461 11.25 15 11.25C7.75389 11.25 1.875 9.32479 1.875 6.96428V4.28572C1.875 1.92521 7.75389 0 15 0C22.2461 0 28.125 1.92521 28.125 4.28572ZM28.125 10.3125V16.3393C28.125 18.6998 22.2461 20.625 15 20.625C7.75389 20.625 1.875 18.6998 1.875 16.3393V10.3125C4.69482 12.2545 9.85594 13.1585 15 13.1585C20.1441 13.1585 25.3051 12.2545 28.125 10.3125ZM28.125 19.6875V25.7143C28.125 28.0748 22.2461 30 15 30C7.75389 30 1.875 28.0748 1.875 25.7143V19.6875C4.69482 21.6295 9.85594 22.5335 15 22.5335C20.1441 22.5335 25.3051 21.6295 28.125 19.6875Z",
  fill: "#203972"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M28.125 10.3125V16.3393C28.125 18.6998 22.2461 20.625 15 20.625C7.75389 20.625 1.875 18.6998 1.875 16.3393V10.3125C4.69482 12.2545 9.85594 13.1585 15 13.1585C20.1441 13.1585 25.3051 12.2545 28.125 10.3125Z",
  fill: "#203972"
}, null, -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 6,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M25.3125 0H4.6875C3.13477 0 1.875 1.25977 1.875 2.8125V27.1875C1.875 28.7402 3.13477 30 4.6875 30H25.3125C26.8652 30 28.125 28.7402 28.125 27.1875V2.8125C28.125 1.25977 26.8652 0 25.3125 0ZM15 28.125C13.9629 28.125 13.125 27.2871 13.125 26.25C13.125 25.2129 13.9629 24.375 15 24.375C16.0371 24.375 16.875 25.2129 16.875 26.25C16.875 27.2871 16.0371 28.125 15 28.125ZM25.3125 21.7969C25.3125 22.1836 24.9961 22.5 24.6094 22.5H5.39062C5.00391 22.5 4.6875 22.1836 4.6875 21.7969V3.51562C4.6875 3.12891 5.00391 2.8125 5.39062 2.8125H24.6094C24.9961 2.8125 25.3125 3.12891 25.3125 3.51562V21.7969Z",
  fill: "#203972"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M15 28.125C13.9629 28.125 13.125 27.2871 13.125 26.25C13.125 25.2129 13.9629 24.375 15 24.375C16.0371 24.375 16.875 25.2129 16.875 26.25C16.875 27.2871 16.0371 28.125 15 28.125Z",
  fill: "#203972"
}, null, -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 7,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M28.559 18.498L26.0629 17.0566C26.3148 15.6973 26.3148 14.3027 26.0629 12.9434L28.559 11.5019C28.8461 11.3379 28.975 10.998 28.8812 10.6816C28.2308 8.5957 27.1234 6.70898 25.6761 5.13867C25.4535 4.89843 25.0902 4.83984 24.809 5.0039L22.3129 6.44531C21.264 5.54296 20.057 4.8457 18.7504 4.38867V1.51171C18.7504 1.18359 18.5218 0.896478 18.1996 0.826166C16.0492 0.345697 13.8461 0.369134 11.8011 0.826166C11.4789 0.896478 11.2504 1.18359 11.2504 1.51171V4.39453C9.94958 4.85742 8.74255 5.55468 7.68786 6.45117L5.19762 5.00976C4.91051 4.8457 4.55309 4.89843 4.33044 5.14453C2.88317 6.70898 1.77575 8.5957 1.12536 10.6875C1.02575 11.0039 1.16051 11.3437 1.44762 11.5078L3.94372 12.9492C3.69176 14.3086 3.69176 15.7031 3.94372 17.0625L1.44762 18.5039C1.16051 18.668 1.03161 19.0078 1.12536 19.3242C1.77575 21.4101 2.88317 23.2969 4.33044 24.8672C4.55309 25.1074 4.91637 25.166 5.19762 25.0019L7.69372 23.5605C8.74255 24.4629 9.94958 25.1601 11.2562 25.6172V28.5C11.2562 28.8281 11.4847 29.1152 11.807 29.1855C13.9574 29.666 16.1605 29.6426 18.2054 29.1855C18.5277 29.1152 18.7562 28.8281 18.7562 28.5V25.6172C20.057 25.1543 21.264 24.457 22.3187 23.5605L24.8148 25.0019C25.1019 25.166 25.4593 25.1133 25.682 24.8672C27.1293 23.3027 28.2367 21.416 28.8871 19.3242C28.975 19.0019 28.8461 18.6621 28.559 18.498ZM15.0004 19.6875C12.4164 19.6875 10.3129 17.584 10.3129 15C10.3129 12.416 12.4164 10.3125 15.0004 10.3125C17.5843 10.3125 19.6879 12.416 19.6879 15C19.6879 17.584 17.5843 19.6875 15.0004 19.6875Z",
  fill: "#203972"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M15 19.6875C15.9375 18.75 17.25 17.584 17.25 15C17.25 12.416 15.75 11.0625 15 10.3125C17.584 10.3125 19.6875 12.416 19.6875 15C19.6875 17.584 17.584 19.6875 15 19.6875Z",
  fill: "#203972"
}, null, -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 8,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_5962_2239)\" data-v-91752240><path opacity=\"0.3\" d=\"M20.5898 18.7852L15 24.375L9.41016 18.7852C5.2207 18.9668 1.875 22.3945 1.875 26.625V27.1875C1.875 28.7402 3.13477 30 4.6875 30H25.3125C26.8652 30 28.125 28.7402 28.125 27.1875V26.625C28.125 22.3945 24.7793 18.9668 20.5898 18.7852ZM2.67188 4.67578L3.04688 4.76367V8.18555C2.63672 8.43164 2.34375 8.85938 2.34375 9.375C2.34375 9.86719 2.61328 10.2773 2.99414 10.5293L2.08008 14.1797C1.98047 14.584 2.20313 15 2.52539 15H4.97461C5.29688 15 5.51953 14.584 5.41992 14.1797L4.50586 10.5293C4.88672 10.2773 5.15625 9.86719 5.15625 9.375C5.15625 8.85938 4.86328 8.43164 4.45312 8.18555V5.10352L8.32031 6.03516C7.81641 7.04297 7.5 8.16797 7.5 9.375C7.5 13.5176 10.8574 16.875 15 16.875C19.1426 16.875 22.5 13.5176 22.5 9.375C22.5 8.16797 22.1895 7.04297 21.6797 6.03516L27.3223 4.67578C28.3887 4.41797 28.3887 3.08789 27.3223 2.83008L16.166 0.134766C15.4043 -0.046875 14.6016 -0.046875 13.8398 0.134766L2.67188 2.82422C1.61133 3.08203 1.61133 4.41797 2.67188 4.67578Z\" fill=\"#203972\" data-v-91752240></path><path d=\"M2.67236 4.67578L3.04736 4.76367V8.18555C2.63721 8.43164 2.34424 8.85938 2.34424 9.375C2.34424 9.86719 2.61377 10.2773 2.99463 10.5293L2.08057 14.1797C1.98096 14.584 2.20361 15 2.52588 15H4.9751C5.29736 15 5.52002 14.584 5.42041 14.1797L4.50635 10.5293C4.88721 10.2773 5.15674 9.86719 5.15674 9.375C5.15674 8.85938 4.86377 8.43164 4.45361 8.18555V5.10352L8.3208 6.03516C7.81689 7.04297 7.50049 8.16797 7.50049 9.375C7.50049 13.5176 10.8579 16.875 15.0005 16.875C19.1431 16.875 22.5005 13.5176 22.5005 9.375C22.5005 8.16797 22.1899 7.04297 21.6802 6.03516L27.3228 4.67578C28.3892 4.41797 28.3892 3.08789 27.3228 2.83008L16.1665 0.134766C15.4048 -0.046875 14.6021 -0.046875 13.8403 0.134766L2.67236 2.82422C1.61182 3.08203 1.61182 4.41797 2.67236 4.67578Z\" fill=\"#203972\" data-v-91752240></path></g><defs data-v-91752240><clipPath id=\"clip0_5962_2239\" data-v-91752240><rect width=\"30\" height=\"30\" fill=\"white\" data-v-91752240></rect></clipPath></defs>", 2)
const _hoisted_28 = [
  _hoisted_26
]
const _hoisted_29 = {
  style: {"height":"82px"},
  class: "d-flex flex-column gap-2 justify-content-center"
}
const _hoisted_30 = { style: {"font-size":"14px"} }
const _hoisted_31 = {
  key: 0,
  class: "d-flex flex-row gap-2 align-items-center"
}
const _hoisted_32 = { style: {"font-size":"12px"} }
const _hoisted_33 = { style: {"font-size":"12px"} }
const _hoisted_34 = {
  key: 1,
  class: "d-flex flex-row gap-2"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "aguardando...", -1))
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataInicio && _ctx.dataFim)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.dataInicio && !_ctx.dataFim)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.dataInicio)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.passo === 1)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.passo === 2)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.passo === 3)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16))
      : _createCommentVNode("", true),
    (_ctx.passo === 4)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_20))
      : _createCommentVNode("", true),
    (_ctx.passo === 5)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_21, _hoisted_24))
      : _createCommentVNode("", true),
    (_ctx.passo === 6)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_28))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("h6", _hoisted_30, _toDisplayString(_ctx.nameStatus), 1),
      (_ctx.dataInicio)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.dataTemplate(_ctx.dataInicio)), 1),
            (_ctx.dataInicio !== _ctx.dataFim)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" - "),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.dataTemplate(_ctx.dataFim) || 'aguardando...'), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
    ])
  ]))
}